import { useContext, useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Tab, Tabs } from "react-bootstrap";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { Accordion, AccordionDetails, AccordionSummary, Grid } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import ImageIcon from "@mui/icons-material/Image";
import DeleteIcon from "@mui/icons-material/Delete";
import { ChevronRight, KeyboardArrowDown, Edit } from "@mui/icons-material";
import {
  getFullActa,
  getNombreInspector,
  getInfoTitular,
  obtenerRecibo,
  generarCedulaDeNotificacion,
  actaVencida,
} from "./handlers";
import FormPersonaMultada from "./FormPersonaMultada";
import FormEditarPersonaMultada from "./FormEditarPersonaMultada";
import { renderModal } from "../handlers";
import MuniSpinner from "../../components/MuniSpinner";
import ImageCarousel from "../../components/ImageCarousel";
import Articulo from "../../components/Articulo";
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner";
import { UserContext } from "../../context";
import PulseOpacitySpinner from "../../components/MuniSpinner/PulseOpacitySpinner";
import FormDarDeBaja from "./FormDarDeBaja";
import FormCargaEnSinai from "./FormCargaEnSinai";
import FormMarcarActaComoPagada from "./FormMarcarActaComoPagada";
import FormGenerarCedula from "./FormGenerarCedula";

const Acta = () => {
  const { id } = useParams();
  const [acta, setActa] = useState(null);
  const [recibos, setRecibos] = useState(null);
  const [infoTitular, setInfoTitular] = useState(null);
  const [infoInspector, setInfoInspector] = useState(null);
  const [images, setImages] = useState(null);
  const [imagenActa, setImagenActa] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCedula, setIsLoadingCedula] = useState(false);
  const [isLoadingInfoTitular, setIsLoadingInfoTitular] = useState(false);
  const [isLoadingInfoInspector, setIsLoadingInfoInspector] = useState(false);
  const [expanded, setExpanded] = useState(-1);
  const [modalLlenarInfoIsOpen, setModalLlenarInfoIsOpen] = useState(false);
  const [modalDarDeBajaIsOpen, setModalDarDeBajaIsOpen] = useState(false);
  const [modalCargadaEnSinaiIsOpen, setModalCargadaEnSinaiIsOpen] = useState(false);
  const [modalMarcarActaComoPagadaIsOpen, setModalMarcarActaComoPagadaIsOpen] = useState(false);
  const [modalEditarInfoIsOpen, setModalEditarInfoIsOpen] = useState(false);
  const [modalImagenActaIsOpen, setModalImagenActaIsOpen] = useState(false);
  const [modalGenerarCedulaIsOpen, setModalGenerarCedulaIsOpen] = useState(false);
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();

  // console.log(recibos)

  useEffect(() => {
    if (ua.hasPermission("actas.view")) {
      getFullActa(setIsLoading, setActa, setRecibos, id, setImages, setImagenActa);
    } else {
      navigate("/");
    }

    return () => {
      setActa(null);
    };
  }, [id, setActa, navigate, ua]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : 0);
  };
  return (
    <div>
      {isLoading ? (
        <MuniSpinner />
      ) : !isLoading && acta ? (
        <>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='d-sm-flex  gap-4 align-items-center '>
              <h2 className='mb-0'>Acta {acta.numero_acta}</h2>
              {ua.hasPermission("actas.marcarCargaEnSinai") &&
                !acta.fecha_pago &&
                !acta.observacion &&
                !acta.fecha_cargada_en_sinai &&
                actaVencida(acta.created_at) && (
                  <>
                    <Button onClick={() => setModalCargadaEnSinaiIsOpen(true)}>Marcar como cargada en SINAI</Button>
                    {renderModal(
                      modalCargadaEnSinaiIsOpen,
                      setModalCargadaEnSinaiIsOpen,
                      `Marcar acta ${acta.dependencia}-${acta.numero_acta} como cargada en SINAI`,
                      <>
                        <FormCargaEnSinai
                          setModalCargadaEnSinaiIsOpen={setModalCargadaEnSinaiIsOpen}
                          acta={acta}
                          setActa={setActa}
                        />
                      </>
                    )}
                  </>
                )}
              {ua.hasPermission("actas.marcarComoPagada") &&
                recibos &&
                !acta.fecha_pago &&
                !acta.observacion &&
                !acta.fecha_cargada_en_sinai && (
                  <>
                    <Button onClick={() => setModalMarcarActaComoPagadaIsOpen(true)}>Marcar como pagada</Button>
                    {renderModal(
                      modalMarcarActaComoPagadaIsOpen,
                      setModalMarcarActaComoPagadaIsOpen,
                      `Marcar acta ${acta.dependencia}-${acta.numero_acta} como pagada`,
                      <>
                        <FormMarcarActaComoPagada
                          setModalMarcarActaComoPagadaIsOpen={setModalMarcarActaComoPagadaIsOpen}
                          acta={acta}
                          setActa={setActa}
                          setRecibos={setRecibos}
                        />
                      </>
                    )}
                  </>
                )}
              {/* {ua.hasRole("sudo") && !acta.observacion && !acta.fecha_cargada_en_sinai && (
                <>
                  <Button variant='danger' onClick={() => setModalDarDeBajaIsOpen(true)}>
                    <DeleteIcon /> Dar de Baja
                  </Button>
                  {renderModal(
                    modalDarDeBajaIsOpen,
                    setModalDarDeBajaIsOpen,
                    `Dar de baja acta ${acta.dependencia}-${acta.numero_acta}`,
                    <>
                      <FormDarDeBaja setModalDarDeBajaIsOpen={setModalDarDeBajaIsOpen} acta={acta} setActa={setActa} />
                    </>
                  )}
                </>
              )} */}
            </div>
            <Link className='btn btn-primary' to={"/actas"}>
              Volver
            </Link>
          </div>
          {acta.observacion && (
            <div className='alert alert-danger mt-3'>
              Acta dada de baja. Observación: <span className='fw-bold'>{acta.observacion}</span>
            </div>
          )}

          {acta.fecha_cargada_en_sinai && (
            <div className='alert alert-danger mt-3'>
              <p className='mb-0'>
                <span className='fw-semibold'>El acta se encuentra cargada en SINAI.</span>
              </p>
              <p className='mb-0'>
                <span className='fw-semibold'>Número de acta en SINAI:</span> {acta.numero_acta_sinai}
              </p>
              <p className='mb-0'>
                <span className='fw-semibold'>Observación:</span> {acta.observacion_carga_en_sinai ?? "Sin observación"}
              </p>
            </div>
          )}

          {!acta.id_persona_multado && !acta.observacion ? (
            <div className='alert alert-warning mt-4'>
              <p className='mb-0'>Datos del acta incompletos.</p>
              {(ua.hasRole("transito") || ua.hasRole("vista-transito") || ua.hasRole("tribunales")) && (
                <div>
                  <p className='mb-0'>Por favor, rellene los datos de la persona multada.</p>
                  {!acta.id_persona_multado && !acta.persona_multada && (
                    <div>
                      <Button onClick={() => setModalLlenarInfoIsOpen(true)}>Completar información</Button>
                      {renderModal(
                        modalLlenarInfoIsOpen,
                        setModalLlenarInfoIsOpen,
                        "Completar información de la persona multada",
                        <>
                          <FormPersonaMultada
                            setModalLlenarInfoIsOpen={setModalLlenarInfoIsOpen}
                            dniActa={acta.dni_multado}
                            idActa={acta.id}
                            setActa={setActa}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          ) : null}
          <hr />
          <Grid container>
            <Grid item xs={12} md={6}>
              <h5 className='text-decoration-underline mb-3'>Información General</h5>
              <div>
                <ul className='mb-0 gap-y-2'>
                  <li>Numero de Acta: {acta.numero_acta ? acta.numero_acta : "Sin numero de acta"} </li>
                  <li>Dependencia: {acta.dependencia ? acta.dependencia : "Sin dependencia"} </li>
                  <li className={!infoInspector ? "mb-1" : " "}>
                    Inspector
                    {!infoInspector && (
                      <Button
                        className={"ms-1 d-inline " + (infoInspector && "d-none")}
                        disabled={isLoadingInfoInspector}
                        onClick={() => {
                          getNombreInspector(acta.user_id_inspector, setInfoInspector, setIsLoadingInfoInspector);
                        }}
                      >
                        {isLoadingInfoInspector ? (
                          <ContainedMuniSpinner height={25} width={25} size={35} />
                        ) : (
                          "Ver información del inspector"
                        )}
                      </Button>
                    )}
                  </li>
                  {infoInspector && (
                    <ul>
                      <li>Nombre completo: {infoInspector}</li>
                    </ul>
                  )}
                  <li>
                    Persona multada:{" "}
                    {acta.id_persona_multado ? (
                      <>
                        {ua.hasPermission("usuarios.edit") && (
                          <>
                            <Button className='d-inline' onClick={() => setModalEditarInfoIsOpen(true)}>
                              <Edit /> Editar
                            </Button>
                            <div>
                              {renderModal(
                                modalEditarInfoIsOpen,
                                setModalEditarInfoIsOpen,
                                "Editar información de la persona multada",
                                <>
                                  <FormEditarPersonaMultada
                                    setModalEditarInfoIsOpen={setModalEditarInfoIsOpen}
                                    personaMultada={acta.persona_multada}
                                    idActa={acta.id}
                                    setActa={setActa}
                                  />
                                </>
                              )}
                            </div>
                          </>
                        )}
                        <ul>
                          <li>Nombre: {acta.persona_multada.nombre}</li>
                          <li>Apellido: {acta.persona_multada.apellido}</li>
                          <li>DNI: {acta.persona_multada.numero_de_documento}</li>
                          <li>Direccion: {acta.persona_multada.direccion}</li>
                          <li>Provincia: {acta.persona_multada.provincia}</li>
                          <li>Localidad: {acta.persona_multada.localidad}</li>
                        </ul>
                      </>
                    ) : (
                      "Información incompleta"
                    )}
                  </li>
                  {acta.correo_multado && <li>Correo de notificación: {acta.correo_multado}</li>}
                  <li>
                    Patente:{" "}
                    {acta.patente && (
                      <>
                        <span className='text-uppercase'> {acta.patente} </span>
                        {infoTitular !== "" && (
                          <Button
                            className='d-inline'
                            disabled={isLoadingInfoTitular}
                            onClick={() => {
                              getInfoTitular(acta.patente, setInfoTitular, setIsLoadingInfoTitular);
                            }}
                          >
                            {isLoadingInfoTitular ? (
                              <ContainedMuniSpinner height={25} width={25} size={35} />
                            ) : infoTitular ? (
                              <ReplayIcon />
                            ) : (
                              "Ver informacion del titular"
                            )}
                          </Button>
                        )}
                        {infoTitular ? (
                          <>
                            <p className='mb-0'>Informacion del Titular:</p>
                            <ul>
                              <li>Razon social: {infoTitular.value?.titular.razonSocial}</li>
                              <li>Identificacion: {infoTitular.value?.titular.identificacion}</li>
                              <li>
                                Deuda:{" "}
                                <span
                                  className={
                                    (infoTitular.value?.estado === "SIN DEUDA"
                                      ? "span-deuda-success"
                                      : "span-deuda-alert") + " d-inline-block m-0 span-deuda"
                                  }
                                >
                                  {infoTitular.value?.estado}
                                </span>{" "}
                              </li>
                            </ul>
                          </>
                        ) : infoTitular === "" ? (
                          <ul>
                            <li>Vehiculo inexistente o no radicado en la ciudad de Neuquén</li>
                          </ul>
                        ) : null}
                      </>
                    )}
                  </li>
                  <li className=''>
                    Fecha de Notificación:{" "}
                    {acta.fecha_notificacion ? acta.fecha_notificacion : "Sin fecha de notificación"}
                    {ua.hasPermission("actas.generarCedulaDeNotificacion") &&
                      acta.articulos &&
                      acta.articulos.length > 0 && (
                        <>
                          <Button
                            variant='primary'
                            type='submit'
                            disabled={isLoadingCedula}
                            onClick={() => setModalGenerarCedulaIsOpen(true)}
                          >
                            Generar cédula de notificación
                          </Button>
                          {renderModal(
                            modalGenerarCedulaIsOpen,
                            setModalGenerarCedulaIsOpen,
                            "Generar cédula de notificación",
                            <FormGenerarCedula
                              acta={acta}
                              setActa={setActa}
                              setModalGenerarCedulaIsOpen={setModalGenerarCedulaIsOpen}
                            />
                          )}
                        </>
                      )}
                  </li>
                  <li>Fecha Pago: {acta.fecha_pago ? acta.fecha_pago : "Sin fecha pago"} </li>
                </ul>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className='w-100 mb-2'>
                <h5 className='text-decoration-underline'>Acta</h5>
                {imagenActa[0]?.file ? (
                  <>
                    <Button className='mb-3' onClick={() => setModalImagenActaIsOpen(true)}>
                      <ImageIcon /> Ver todas las imágenes{" "}
                    </Button>
                    <img src={imagenActa[0]?.file} alt='Acta' className='w-100' />
                  </>
                ) : (
                  <p>Sin imágen del acta</p>
                )}
              </div>
            </Grid>
            <div className='mt-2'>
              <div>
                {renderModal(
                  modalImagenActaIsOpen,
                  setModalImagenActaIsOpen,
                  `Imagen del acta ${acta.dependencia + -+acta.numero_acta}`,
                  <Tabs defaultActiveKey='acta' id='uncontrolled-tab-example' className='mb-3'>
                    <Tab eventKey='acta' title='Acta'>
                      <div className='w-100'>
                        <img src={imagenActa[0]?.file} alt='Acta' className='w-100' />
                      </div>
                    </Tab>
                    {images && images.some((image) => image !== null) && (
                      <Tab eventKey='extras' title='Imágenes extra'>
                        <div className='mt-4'>
                          <ImageCarousel images={images} />
                        </div>
                      </Tab>
                    )}
                  </Tabs>,
                  "lg"
                )}
              </div>
            </div>
          </Grid>
          <div style={{ marginTop: "2rem", marginBottom: "2rem" }}>
            {recibos ? (
              recibos.map((recibo, index) => (
                <div key={index}>
                  {index === 0 ? <h5 className='text-decoration-underline'>Historial de recibos:</h5> : null}
                  <Accordion
                    expanded={expanded === `panel${index}`}
                    onChange={handleChange(`panel${index}`)}
                    onClick={() => obtenerRecibo(recibo.historial_recibo.numero_recibo, recibos, setRecibos, setExpanded, index)}
                  >
                    <AccordionSummary className={recibo.historial_recibo.className}>
                      <p className='mb-0'>
                        {expanded === `panel${index}` ? <KeyboardArrowDown /> : <ChevronRight />}
                        Recibo Número {recibo.historial_recibo.numero_recibo} - Monto: ${recibo.historial_recibo.monto}{" "}
                        - Descuento: {recibo.historial_recibo.descuento}% -{" "}
                        <span className='fw-bold'>
                          {recibo.historial_recibo.fecha_pago ? "PAGADO" : "NO PAGADO"}
                          {!!recibo.historial_recibo.vencio && !recibo.historial_recibo.fecha_pago && " - VENCIDO"}
                          <br />
                        </span>
                      </p>
                    </AccordionSummary>
                    <AccordionDetails className='w-100' style={{ height: recibo.data?.recibo ? "700px" : "250px" }}>
                      {recibo?.isLoading ? (
                        <PulseOpacitySpinner />
                      ) : (
                        <iframe
                          src={recibo.data?.recibo?.base64?.recibo}
                          width='100%'
                          height='100%'
                          title={`Recibo ${recibo?.data?.numeroRecibo?.notacionStandard}`}
                        />
                      )}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))
            ) : (
              <p className='alert alert-danger'>No hay recibos para este acta</p>
            )}
          </div>
          <div className='d-flex flex-wrap gap-2'>
            {acta.articulos ? (
              <div className='mt-8'>
                <h5 className='mb-2 text-decoration-underline'>Articulos</h5>
                <div>
                  {acta.articulos && acta.articulos.length > 0 ? (
                    acta.articulos.map((articulo, i) => (
                      <Articulo key={articulo.codigo + i} articulo={articulo} index={i} />
                    ))
                  ) : (
                    <p>Sin articulos seleccionados</p>
                  )}
                </div>
              </div>
            ) : null}
          </div>
          {acta.latitud && acta.longitud && (
            <div>
              <h5 className='mb-2 text-decoration-underline'>Lugar de la contravención:</h5>
              <MapContainer
                style={{ height: "40vh" }}
                center={[acta.latitud, acta.longitud]}
                minZoom={7}
                zoom={16}
                attributionControl={false}
              >
                <TileLayer url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png' />
                <Marker position={[acta.latitud, acta.longitud]}></Marker>
              </MapContainer>
            </div>
          )}
        </>
      ) : (
        <div className='d-flex justify-between w-full gap-2'>
          <Button onClick={() => getFullActa(setIsLoading, setActa, setRecibos, id, setImages, setImagenActa)}>
            Reintentar
          </Button>
          <Link className='btn btn-primary' to={"/actas"}>
            Volver
          </Link>
        </div>
      )}
    </div>
  );
};

export default Acta;
